import { useTray } from "@/app/providers/tray_provider"

import { useGlobalData } from "@/app/global_data"
import { getMembers } from "@/app/metric_utils"
import { Term } from "@/app/types"
import { ComparisonNew } from "@/app/types/comparison_new"
import { Button } from "@/components/buttons/button"
import { ComparisonGroupListTray } from "@/components/comparison_group_list/comparison_group_list.tray"
import { useMemo } from "react"

interface GroupCountButtonProps {
  className?: string
  comparison: ComparisonNew
  term: Term
}

export function GroupCountButton({
  className,
  comparison,
  term,
}: GroupCountButtonProps) {
  const { showTray } = useTray()
  const { entity, entityValues, allValues, chart } = useGlobalData().get()

  if (!entityValues || !allValues) return null

  const members = useMemo(() => {
    return getMembers(entity, comparison, entityValues, allValues, chart, term)
  }, [comparison, entity])

  const filteredMembers = useMemo(() => {
    return members.filter((member) => member.filterIncluded)
  }, [members])

  const membersQtyDisplayText =
    filteredMembers.length !== members.length ?
      `${filteredMembers.length} of ${members.length}`
    : members.length

  return (
    <Button
      color="secondary"
      className={className}
      onClick={() => {
        showTray(
          <ComparisonGroupListTray
            entity={entity}
            comparison={comparison}
            entityValues={entityValues}
            allValues={allValues}
            chart={chart}
          />
        )
      }}>
      <div className="flex items-center gap-1">
        <p>{membersQtyDisplayText}</p>
        <p className="hidden md:block">
          {(entity.isFund() ? " fund" : " firm") +
            (members.length == 1 ? "" : "s")}
        </p>
      </div>
    </Button>
  )
}
